import { render, staticRenderFns } from "./rteBtn.vue?vue&type=template&id=50df1c1e&scoped=true"
import script from "./rteBtn.vue?vue&type=script&lang=ts"
export * from "./rteBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50df1c1e",
  null
  
)

export default component.exports